const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export async function submitLead(leadData) {
  const response = await fetch(`${API}/lead`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(leadData),
  });
  if (!response.ok) {
    throw new Error('Erro ao enviar dados');
  }
  return response.json();
}

export async function generatePhoto(imagesBase64, userName, email) {
  const response = await fetch(`${API}/generate-photo`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ imagesBase64, userName, email }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    const error = new Error(err.detail || 'Falha na geração de imagem');
    error.status = response.status;
    error.code = err.code;
    throw error;
  }
  return response.json();
}

export function getPhotoUrl(photoId) {
  return `${API}/photos/${photoId}`;
}
